import React from "react";
import GetTextoSlug from "../lib/GetTextoSlug";


const FormCampoCBX = ({label, setValor, isRequired, listaOptionsCBX, valor, idSufix}) => {
  
  const codeId=(!idSufix? GetTextoSlug(label):idSufix);
  const idLab=`lab_${codeId}`;
  const idCbx=`cbx_${codeId}`;
  
  
  const simbolRequired = isRequired ? "*" : '';
  const lista = listaOptionsCBX.map((item, index) => {
    return <option key={index} value={item.valor}>{item.label}</option>
  });

  const onChange=(event)=>{
    const valor=event.target.value;
    setValor(valor);
  };
  
  return (
    <div className="row form-group">
      <div className="col-sm-4 col-xs-12">
        <label id={idLab}>{label} {simbolRequired}</label>
      </div>
      <div className="col-sm-8">
        <select className="form-control"
                id={idCbx}
                onChange={onChange}
                value={valor}>
          {lista}
        </select>
      </div>
    </div>
  );
};

export default FormCampoCBX